// class CartDrawer extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener(
//       "keyup",
//       (evt) => evt.code === "Escape" && this.close()
//     );
//     this.querySelector("#CartDrawer-Overlay").addEventListener(
//       "click",
//       this.close.bind(this)
//     );
//     this.setHeaderCartIconAccessibility();
//   }

// // to fixed the reelup add to cart cart iteme quantity update
// async refreshCartIconBubble() {
//   try {
//     const response = await fetch('/?sections=header', {
//       credentials: 'same-origin'
//     });

//     const data = await response.json();
//     const headerHTML = data.header;
//     if (!headerHTML) return;

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(headerHTML, 'text/html');

//     const newBubbles = doc.querySelectorAll('#cart-icon-bubble');
//     const currentBubbles = document.querySelectorAll('#cart-icon-bubble');

//     if (!newBubbles.length || !currentBubbles.length) return;

//     currentBubbles.forEach((currentEl, index) => {
//       const newEl = newBubbles[index] || newBubbles[0];
//       currentEl.innerHTML = newEl.innerHTML;
//     });

//     this.setHeaderCartIconAccessibility();

//   } catch (err) {
//     console.error('Cart icon refresh failed:', err);
//   }
// }
// // to fixed the reelup add to cart cart iteme quantity update

//   setHeaderCartIconAccessibility() {
//     const cartLink = document.querySelector("#cart-icon-bubble");
//     if (!cartLink) return;

//     cartLink.setAttribute("role", "button");
//     cartLink.setAttribute("aria-haspopup", "dialog");
//     cartLink.addEventListener("click", (event) => {
//       event.preventDefault();
//       this.open(cartLink);
//     });
//     cartLink.addEventListener("keydown", (event) => {
//       if (event.code.toUpperCase() === "SPACE") {
//         event.preventDefault();
//         this.open(cartLink);
//       }
//     });
//   }

//   open(triggeredBy) {
//     if (triggeredBy) this.setActiveElement(triggeredBy);
//     const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
//     if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
//       this.setSummaryAccessibility(cartDrawerNote);
//     // here the animation doesn't seem to always get triggered. A timeout seem to help
//     setTimeout(() => {
//       this.classList.add("animate", "active");
//     });

//     this.addEventListener(
//       "transitionend",
//       () => {
//         const containerToTrapFocusOn = this.classList.contains("is-empty")
//           ? this.querySelector(".drawer__inner-empty")
//           : document.getElementById("CartDrawer");
//         const focusElement =
//           this.querySelector(".drawer__inner") ||
//           this.querySelector(".drawer__close");
//         trapFocus(containerToTrapFocusOn, focusElement);
//       },
//       { once: true }
//     );

//     document.body.classList.add("overflow-hidden");
//   }

//   close() {
//     this.classList.remove("active");
//     removeTrapFocus(this.activeElement);
//     document.body.classList.remove("overflow-hidden");
//   }

//   setSummaryAccessibility(cartDrawerNote) {
//     cartDrawerNote.setAttribute("role", "button");
//     cartDrawerNote.setAttribute("aria-expanded", "false");

//     if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
//       cartDrawerNote.setAttribute(
//         "aria-controls",
//         cartDrawerNote.nextElementSibling.id
//       );
//     }

//     cartDrawerNote.addEventListener("click", (event) => {
//       event.currentTarget.setAttribute(
//         "aria-expanded",
//         !event.currentTarget.closest("details").hasAttribute("open")
//       );
//     });

//     cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
//   }

//   renderContents(parsedState) {
//     this.querySelector(".drawer__inner").classList.contains("is-empty") &&
//       this.querySelector(".drawer__inner").classList.remove("is-empty");
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (!sectionElement) return;
//       sectionElement.innerHTML = this.getSectionInnerHTML(
//         parsedState.sections[section.id],
//         section.selector
//       );
//     });
//     console.log("parsedState.sections[section.id]",parsedState.sections[section.id]);
    
//       // to fixed the reelup add to cart cart iteme quantity update
//     this.refreshCartIconBubble();
//      // to fixed the reelup add to cart cart iteme quantity update
//     setTimeout(() => {
//       this.querySelector("#CartDrawer-Overlay").addEventListener(
//         "click",
//         this.close.bind(this)
//       );
//       // this.open();
//     });
//   }

//   renderContentsCustom(parsedState, openDrawer) {
//     document
//       .querySelector("#CartDrawer .drawer__inner")
//       .classList.contains("is-empty") &&
//       document
//         .querySelector("#CartDrawer .drawer__inner")
//         .classList.remove("is-empty");
//     //this.productId = parsedState.id;
//     document
//       .querySelector("cart-drawer")
//       .getSectionsToRender()
//       .forEach((section) => {
//         const sectionElement = section.selector
//           ? document.querySelector(section.selector)
//           : document.getElementById(section.id);

//         // console.log(sectionElement, "sectionElement");
//         // console.log(section.selector, "section.selector");
//         // console.log(parsedState[section.id], "parsedState[section.id]");
//         // console.log("parsedState",parsedState);
//         // console.log(document.querySelector("cart-drawer").getSectionInnerHTML(parsedState[section.id], section.selector););
        
//         // sectionElement.innerHTML = document.querySelector("cart-drawer").getSectionInnerHTML(parsedState[section.id], section.selector);
//       });

//     document.getElementsByClassName("drawer")[0].classList.remove("is-empty");
//      // to fixed the reelup add to cart cart iteme quantity update
//     this.refreshCartIconBubble();
//      // to fixed the reelup add to cart cart iteme quantity update
//     setTimeout(() => {
//       document
//         .querySelector("#CartDrawer #CartDrawer-Overlay")
//         .addEventListener("click", this.close.bind(this));
//       if (openDrawer) {
//         this.open();
//       }
//     });
//   }

//   getSectionInnerHTML(html, selector = ".shopify-section") {
//     console.log("here1");
    
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector).innerHTML;
//   }

//   getSectionsToRender() {
//     return [
//       {
//         id: "cart-drawer",
//         selector: "#CartDrawer",
//       },
//       {
//         id: "cart-icon-bubble",
//       },
//     ];
//   }

//   getSectionDOM(html, selector = ".shopify-section") {
//     return new DOMParser()
//       .parseFromString(html, "text/html")
//       .querySelector(selector);
//   }

//   setActiveElement(element) {
//     this.activeElement = element;
//   }
// }

// customElements.define("cart-drawer", CartDrawer);

// class CartDrawerItems extends CartItems {
//   getSectionsToRender() {
//     return [
//       {
//         id: "CartDrawer",
//         section: "cart-drawer",
//         selector: ".drawer__inner",
//       },
//       {
//         id: "cart-icon-bubble",
//         section: "cart-icon-bubble",
//         selector: ".shopify-section",
//       },
//     ];
//   }
// }

// customElements.define("cart-drawer-items", CartDrawerItems);

// //{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}
// function toggleAtcd(showQtyBar, qty = 0) {
//   const bar = document.querySelector('#pdp-add-to-cart-fn');
//   const barr = document.querySelector('.pdp-add-to-cart-fn');
//   const cta = document.querySelector('#pdp-add-to-cart-fnp');
//   if (showQtyBar) {
//     const q = Math.max(1, parseInt(qty));
//     const v = bar?.querySelector('.qty-value');
//     if (v) v.textContent = String(q);
//     const hid = bar?.querySelector('input[name="quantity"]');
//     if (hid) hid.value = String(q);
//     if (barr) barr.style.display = 'flex';
//     if (bar) bar.style.display = 'flex';
//     if (cta) cta.style.display = 'none';
//   } else {
//     const q = Math.max(1, parseInt(1));
//     const v = bar?.querySelector('.qty-value');
//     if (v) v.textContent = String(q);
//     const hid = bar?.querySelector('input[name="quantity"]');
//     if (hid) hid.value = String(q);
//     if (barr) barr.style.display = 'none';
//     if (bar) bar.style.display = 'none';
//     if (cta) cta.style.display = 'block';
//   }
//   // console.log('toggleAtc');
// }
// document.addEventListener("DOMContentLoaded", function () {
// // new code for pdp cart
// async function handlePdpWhenLoaderHidden(pluscl,vrid) {
//   // start code here for pdp code
//   const isProductPage = document.body.dataset.template === 'product';
//   if (isProductPage) {
//     const variantId =
//       document.querySelector('#product-varient-id, .product-variant-id-bottom')
//         ?.value?.trim() || null;
//   if (Number(variantId) == Number(vrid)) {
//       toggleAtcd(
//       (pluscl) > 0,
//       pluscl
//     );
//   }
//   }
//   // end code here for pdp code
// }

// let isPdpClickInProgress = false;
// document.addEventListener("click", async (e) => {
//   const plusBtn   = e.target.closest(".dev_right-plus-button");
//   const minusBtn  = e.target.closest(".dev_left-minus-button");
//   const deleteBtn = e.target.closest(".cart-remove-button");
//   // figure out which button was actually clicked
//   const clickedBtn = plusBtn || minusBtn || deleteBtn;
//   // If click is not on any of these buttons, ignore
//   if (!clickedBtn) return;
//     // :one: go to the cart line item wrapper (change ".cart-item" to your actual class)
//   const rowsd = clickedBtn.closest(".template-cart-item"); // e.g. ".cart-item", ".cart-drawer-item", etc.
//   if (!rowsd) return;
//   // :two: find the input inside that row
//   const inputdf = rowsd.querySelector(".dev_quantity_input");
//   if (!inputdf) return;
//   // :three: get data-quantity-variant-id and current quantity
//   const variantIder  = inputdf.dataset.quantityVariantId; // "42792882045093"
//   const cartQtydr    = Number(inputdf.value);             // 3 in your example
//   console.log("variantId:", variantIder, "qty:", cartQtydr);
//   // If async is running → block clicks
//   if (isPdpClickInProgress) {
//     console.log("Action blocked — PDP update still running");
//     return;
//   }
//   isPdpClickInProgress = true;
//   // :lock: disable the clicked button visually + prevent interaction
//   clickedBtn.style.pointerEvents = "none";
//   clickedBtn.style.opacity = "0.5";
//   try {
//     if (plusBtn) {
//       console.log("PLUS button clicked");
//       await handlePdpWhenLoaderHidden(cartQtydr,variantIder);
//     } else if (minusBtn || deleteBtn) {
//       console.log("MINUS / DELETE button clicked");
//       await handlePdpWhenLoaderHidden(cartQtydr,variantIder);
//     }
//   } finally {
//     // :unlock: re-enable the clicked button
//     clickedBtn.style.pointerEvents = "auto";
//     clickedBtn.style.opacity = "1";
//     isPdpClickInProgress = false;

//   }
// });
// });
// //{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}


// /* ========================= 
//    EMPTY CART SLIDER (FINAL FIX) */
// (function () {
//   let observerStarted = false;
//   let smoothRAF = null; // prevent animation stacking

//   function setupSlider(slider) {
//     if (!slider || slider.__sliderBound) return;
//     slider.__sliderBound = true;

//     const items = Array.from(slider.children);
//     if (!items.length) return;

//     let isDown = false;
//     let startX = 0;
//     let startScroll = 0;
//     let deltaX = 0;

//     const SWIPE_THRESHOLD = 30;

//     function getCenterPosition() {
//       return slider.scrollLeft + slider.clientWidth / 2;
//     }

//     function getClosestIndex() {
//       const center = getCenterPosition();
//       let closestIndex = 0;
//       let closestDistance = Infinity;

//       items.forEach((item, index) => {
//         const itemCenter = item.offsetLeft + item.offsetWidth / 2;
//         const distance = Math.abs(center - itemCenter);

//         if (distance < closestDistance) {
//           closestDistance = distance;
//           closestIndex = index;
//         }
//       });

//       return closestIndex;
//     }

//     function updateActiveItem(index) {
//       items.forEach((item, i) =>
//         item.classList.toggle("active", i === index)
//       );
//     }

//     /* ✅ FIX: stop native momentum before JS animation */
//     function stopMomentumScroll() {
//       const current = slider.scrollLeft;
//       slider.scrollLeft = current + 1;
//       slider.scrollLeft = current;
//     }

//     function scrollToIndex(index) {
//       const item = items[index];
//       if (!item) return;

//       const target =
//         item.offsetLeft -
//         (slider.clientWidth - item.offsetWidth) / 2;

//       updateActiveItem(index);
//       stopMomentumScroll(); // 🔥 KEY FIX
//       smoothScroll(slider, target, 220);
//     }

//     function snapToItem() {
//       let index = getClosestIndex();

//       if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
//         index = deltaX < 0 ? index + 1 : index - 1;
//       }

//       index = Math.max(0, Math.min(items.length - 1, index));
//       scrollToIndex(index);
//     }

//     function stopDrag() {
//       isDown = false;
//       slider.classList.remove("grabbing");
//       document.body.style.userSelect = "";
//       snapToItem();
//     }

//     /* ===== Mouse ===== */
//     slider.addEventListener("mousedown", (e) => {
//       isDown = true;
//       slider.classList.add("grabbing");
//       document.body.style.userSelect = "none";
//       startX = e.pageX;
//       startScroll = slider.scrollLeft;
//       deltaX = 0;
//     });

//     slider.addEventListener("mousemove", (e) => {
//       if (!isDown) return;
//       deltaX = e.pageX - startX;
//       slider.scrollLeft = startScroll - deltaX;
//     });

//     slider.addEventListener("mouseup", stopDrag);
//     slider.addEventListener("mouseleave", () => isDown && stopDrag());

//     /* ===== Touch ===== */
//     slider.addEventListener(
//       "touchstart",
//       (e) => {
//         startX = e.touches[0].clientX;
//         startScroll = slider.scrollLeft;
//         deltaX = 0;
//       },
//       { passive: true }
//     );

//     slider.addEventListener(
//       "touchmove",
//       (e) => {
//         deltaX = e.touches[0].clientX - startX;
//         slider.scrollLeft = startScroll - deltaX;
//       },
//       { passive: true }
//     );

//     slider.addEventListener("touchend", snapToItem);
//   }

//   /* ===== Smooth Scroll (STABLE) ===== */
//   function smoothScroll(element, target, duration) {
//     if (smoothRAF) cancelAnimationFrame(smoothRAF);

//     const start = element.scrollLeft;
//     const distance = target - start;
//     const startTime = performance.now();

//     function easeOut(t) {
//       return 1 - Math.pow(1 - t, 4);
//     }

//     function animate(time) {
//       const progress = Math.min((time - startTime) / duration, 1);
//       element.scrollLeft = start + distance * easeOut(progress);

//       if (progress < 1) {
//         smoothRAF = requestAnimationFrame(animate);
//       }
//     }

//     smoothRAF = requestAnimationFrame(animate);
//   }

//   /* ===== Observe Cart Drawer ===== */
//   function watchEmptyCart() {
//     if (observerStarted) return;
//     observerStarted = true;

//     const observer = new MutationObserver(() => {
//       const slider = document.getElementById("empty-slider");
//       if (slider) setupSlider(slider);
//     });

//     observer.observe(document.body, {
//       childList: true,
//       subtree: true,
//     });
//   }

//   document.addEventListener("DOMContentLoaded", watchEmptyCart);
// })();
// // end empty cart slider script


class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();
  }

// to fixed the reelup add to cart cart iteme quantity update
async refreshCartIconBubble() {
  try {
    const response = await fetch('/?sections=header', {
      credentials: 'same-origin'
    });

    const data = await response.json();
    const headerHTML = data.header;
    if (!headerHTML) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(headerHTML, 'text/html');

    const newBubbles = doc.querySelectorAll('#cart-icon-bubble');
    const currentBubbles = document.querySelectorAll('#cart-icon-bubble');

    if (!newBubbles.length || !currentBubbles.length) return;

    currentBubbles.forEach((currentEl, index) => {
      const newEl = newBubbles[index] || newBubbles[0];
      currentEl.innerHTML = newEl.innerHTML;
    });

    this.setHeaderCartIconAccessibility();

  } catch (err) {
    console.error('Cart icon refresh failed:', err);
  }
}
// to fixed the reelup add to cart cart iteme quantity update

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
      // to fixed the reelup add to cart cart iteme quantity update
    this.refreshCartIconBubble();
     // to fixed the reelup add to cart cart iteme quantity update
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      // this.open();
    });
  }

  renderContentsCustom(parsedState, openDrawer) {
    document
      .querySelector("#CartDrawer .drawer__inner")
      .classList.contains("is-empty") &&
      document
        .querySelector("#CartDrawer .drawer__inner")
        .classList.remove("is-empty");
    //this.productId = parsedState.id;
    document
      .querySelector("cart-drawer")
      .getSectionsToRender()
      .forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        console.log(sectionElement, "test2");

        // console.log(section, "sectiontest2");
        
        sectionElement.innerHTML = document.querySelector("cart-drawer").getSectionInnerHTML(parsedState[section.id], section.selector);
      });

    document.getElementsByClassName("drawer")[0].classList.remove("is-empty");
     // to fixed the reelup add to cart cart iteme quantity update
    this.refreshCartIconBubble();
     // to fixed the reelup add to cart cart iteme quantity update
    setTimeout(() => {
      document
        .querySelector("#CartDrawer #CartDrawer-Overlay")
        .addEventListener("click", this.close.bind(this));
      if (openDrawer) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

//{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}
function toggleAtcd(showQtyBar, qty = 0) {
  const bar = document.querySelector('#pdp-add-to-cart-fn');
  const barr = document.querySelector('.pdp-add-to-cart-fn');
  const cta = document.querySelector('#pdp-add-to-cart-fnp');
  if (showQtyBar) {
    const q = Math.max(1, parseInt(qty));
    const v = bar?.querySelector('.qty-value');
    if (v) v.textContent = String(q);
    const hid = bar?.querySelector('input[name="quantity"]');
    if (hid) hid.value = String(q);
    if (barr) barr.style.display = 'flex';
    if (bar) bar.style.display = 'flex';
    if (cta) cta.style.display = 'none';
  } else {
    const q = Math.max(1, parseInt(1));
    const v = bar?.querySelector('.qty-value');
    if (v) v.textContent = String(q);
    const hid = bar?.querySelector('input[name="quantity"]');
    if (hid) hid.value = String(q);
    if (barr) barr.style.display = 'none';
    if (bar) bar.style.display = 'none';
    if (cta) cta.style.display = 'block';
  }
  // console.log('toggleAtc');
}
document.addEventListener("DOMContentLoaded", function () {
// new code for pdp cart
async function handlePdpWhenLoaderHidden(pluscl,vrid) {
  // start code here for pdp code
  const isProductPage = document.body.dataset.template === 'product';
  if (isProductPage) {
    const variantId =
      document.querySelector('#product-varient-id, .product-variant-id-bottom')
        ?.value?.trim() || null;
  if (Number(variantId) == Number(vrid)) {
      toggleAtcd(
      (pluscl) > 0,
      pluscl
    );
  }
  }
  // end code here for pdp code
}

let isPdpClickInProgress = false;
document.addEventListener("click", async (e) => {
  const plusBtn   = e.target.closest(".dev_right-plus-button");
  const minusBtn  = e.target.closest(".dev_left-minus-button");
  const deleteBtn = e.target.closest(".cart-remove-button");
  // figure out which button was actually clicked
  const clickedBtn = plusBtn || minusBtn || deleteBtn;
  // If click is not on any of these buttons, ignore
  if (!clickedBtn) return;
    // :one: go to the cart line item wrapper (change ".cart-item" to your actual class)
  const rowsd = clickedBtn.closest(".template-cart-item"); // e.g. ".cart-item", ".cart-drawer-item", etc.
  if (!rowsd) return;
  // :two: find the input inside that row
  const inputdf = rowsd.querySelector(".dev_quantity_input");
  if (!inputdf) return;
  // :three: get data-quantity-variant-id and current quantity
  const variantIder  = inputdf.dataset.quantityVariantId; // "42792882045093"
  const cartQtydr    = Number(inputdf.value);             // 3 in your example
  console.log("variantId:", variantIder, "qty:", cartQtydr);
  // If async is running → block clicks
  if (isPdpClickInProgress) {
    console.log("Action blocked — PDP update still running");
    return;
  }
  isPdpClickInProgress = true;
  // :lock: disable the clicked button visually + prevent interaction
  clickedBtn.style.pointerEvents = "none";
  clickedBtn.style.opacity = "0.5";
  try {
    if (plusBtn) {
      console.log("PLUS button clicked");
      await handlePdpWhenLoaderHidden(cartQtydr,variantIder);
    } else if (minusBtn || deleteBtn) {
      console.log("MINUS / DELETE button clicked");
      await handlePdpWhenLoaderHidden(cartQtydr,variantIder);
    }
  } finally {
    // :unlock: re-enable the clicked button
    clickedBtn.style.pointerEvents = "auto";
    clickedBtn.style.opacity = "1";
    isPdpClickInProgress = false;

  }
});
});
//{% comment %}(11-11-2025) plus and minus logic added id="product-varient-id" {% endcomment %}


/* ========================= 
   EMPTY CART SLIDER (FINAL FIX) */
(function () {
  let observerStarted = false;
  let smoothRAF = null; // prevent animation stacking

  function setupSlider(slider) {
    if (!slider || slider.__sliderBound) return;
    slider.__sliderBound = true;

    const items = Array.from(slider.children);
    if (!items.length) return;

    let isDown = false;
    let startX = 0;
    let startScroll = 0;
    let deltaX = 0;

    const SWIPE_THRESHOLD = 30;

    function getCenterPosition() {
      return slider.scrollLeft + slider.clientWidth / 2;
    }

    function getClosestIndex() {
      const center = getCenterPosition();
      let closestIndex = 0;
      let closestDistance = Infinity;

      items.forEach((item, index) => {
        const itemCenter = item.offsetLeft + item.offsetWidth / 2;
        const distance = Math.abs(center - itemCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function updateActiveItem(index) {
      items.forEach((item, i) =>
        item.classList.toggle("active", i === index)
      );
    }

    /* ✅ FIX: stop native momentum before JS animation */
    function stopMomentumScroll() {
      const current = slider.scrollLeft;
      slider.scrollLeft = current + 1;
      slider.scrollLeft = current;
    }

    function scrollToIndex(index) {
      const item = items[index];
      if (!item) return;

      const target =
        item.offsetLeft -
        (slider.clientWidth - item.offsetWidth) / 2;

      updateActiveItem(index);
      stopMomentumScroll(); // 🔥 KEY FIX
      smoothScroll(slider, target, 220);
    }

    function snapToItem() {
      let index = getClosestIndex();

      if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
        index = deltaX < 0 ? index + 1 : index - 1;
      }

      index = Math.max(0, Math.min(items.length - 1, index));
      scrollToIndex(index);
    }

    function stopDrag() {
      isDown = false;
      slider.classList.remove("grabbing");
      document.body.style.userSelect = "";
      snapToItem();
    }

    /* ===== Mouse ===== */
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("grabbing");
      document.body.style.userSelect = "none";
      startX = e.pageX;
      startScroll = slider.scrollLeft;
      deltaX = 0;
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      deltaX = e.pageX - startX;
      slider.scrollLeft = startScroll - deltaX;
    });

    slider.addEventListener("mouseup", stopDrag);
    slider.addEventListener("mouseleave", () => isDown && stopDrag());

    /* ===== Touch ===== */
    slider.addEventListener(
      "touchstart",
      (e) => {
        startX = e.touches[0].clientX;
        startScroll = slider.scrollLeft;
        deltaX = 0;
      },
      { passive: true }
    );

    slider.addEventListener(
      "touchmove",
      (e) => {
        deltaX = e.touches[0].clientX - startX;
        slider.scrollLeft = startScroll - deltaX;
      },
      { passive: true }
    );

    slider.addEventListener("touchend", snapToItem);
  }

  /* ===== Smooth Scroll (STABLE) ===== */
  function smoothScroll(element, target, duration) {
    if (smoothRAF) cancelAnimationFrame(smoothRAF);

    const start = element.scrollLeft;
    const distance = target - start;
    const startTime = performance.now();

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function animate(time) {
      const progress = Math.min((time - startTime) / duration, 1);
      element.scrollLeft = start + distance * easeOut(progress);

      if (progress < 1) {
        smoothRAF = requestAnimationFrame(animate);
      }
    }

    smoothRAF = requestAnimationFrame(animate);
  }

  /* ===== Observe Cart Drawer ===== */
  function watchEmptyCart() {
    if (observerStarted) return;
    observerStarted = true;

    const observer = new MutationObserver(() => {
      const slider = document.getElementById("empty-slider");
      if (slider) setupSlider(slider);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.addEventListener("DOMContentLoaded", watchEmptyCart);
})();
// end empty cart slider script
